export default "./images/survio-lqe2m-assets-nps.png";